import { useMemo } from 'react';
import type { SeriesColumnOptions } from 'highcharts';
import { ColumnChart } from '@forge/charts';
import { useTheme } from '@forge/common';
import type { DashboardTrendPoint } from '@/api/dashboard';
import ChartCard from './ChartCard';
import { getAccentColors } from './chartColors';

interface ReleaseCadenceChartProps {
  points: DashboardTrendPoint[];
}

const ReleaseCadenceChart = ({ points }: ReleaseCadenceChartProps) => {
  const { isDark } = useTheme();

  const series = useMemo<SeriesColumnOptions[]>(() => {
    const accents = getAccentColors(isDark);

    return [
      {
        type: 'column',
        name: 'Releases',
        data: points.map((point) => point.releases),
        color: accents.amber,
      },
    ];
  }, [points, isDark]);

  return (
    <ChartCard
      title="Release cadence"
      subtitle="Published releases per month across platform repositories"
    >
      <ColumnChart
        series={series}
        chart={{ height: 300, spacing: [16, 16, 12, 8] }}
        xAxis={{ categories: points.map((point) => point.label), tickLength: 0 }}
        yAxis={{ title: { text: undefined }, allowDecimals: false }}
        legend={{ enabled: false }}
        tooltip={{ pointFormat: '<b>{point.y}</b> releases' }}
        plotOptions={{ column: { borderRadius: 4, maxPointWidth: 40 } }}
      />
    </ChartCard>
  );
};

export type { ReleaseCadenceChartProps };
export default ReleaseCadenceChart;
